const BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  close: ['far', 'xmark'],
  ellipsis: ['far', 'ellipsis'],
  expand: ['far', 'list'],
  pin: ['far', 'thumbtack'],
  add: ['far', 'circle-plus'],
});

export default BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON;
